import { useLanguage } from '../context/LanguageContext';

const CLIENTS_IMAGE = "https://customer-assets.emergentagent.com/job_515449cf-5538-46e3-93ca-14563ce96337/artifacts/c0fiek5h_clients.avif";

export default function ClientsSection() {
  const { isRomanian } = useLanguage();

  return (
    <section className="py-10 md:py-14 bg-brand-orange" data-testid="clients-section">
      <div className="section-container">
        <div className="text-center mb-6">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 text-white rounded-full text-sm font-semibold border border-white/20 mb-3">
            {isRomanian ? 'Clientii nostri' : 'Our Clients'}
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white mt-3 mb-2">
            {isRomanian ? 'Prieteni fericiti cu PetsBox' : 'Happy friends with PetsBox'}
          </h2>
          <p className="text-white/80 text-base max-w-2xl mx-auto">
            {isRomanian
              ? 'Vezi cum se bucura animalutele de cutiile lor PetsBox!'
              : 'See how pets enjoy their PetsBox deliveries!'}
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <img
            src={CLIENTS_IMAGE}
            alt={isRomanian ? 'Clientii PetsBox' : 'PetsBox Clients'}
            className="w-full h-auto object-cover rounded-2xl"
            data-testid="clients-image"
          />
        </div>
      </div>
    </section>
  );
}
